module.exports = __webpack_public_path__ + "img/ES.999632b1.svg";